import React from 'react';
import Route from './../components/RouteInterceptor.tsx';

const PublicRoute = ({ component: Content, ...rest }) => <Route {...rest} component={Content} />;

export default PublicRoute;
